import { EntityTypes } from '../../../new-lib/constants/common';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';
import { Compound } from '../../../new-lib/types/entity';
import { getImages } from '../../../helpers/common';
import FAQs from '../components/FAQs';
import CoverSection from './components/CoverSection';
import StickyDetails from './components/StickyDetails';
import styled from 'styled-components';
import ExtraFeatures from './components/ExtraFeatures';
import LaunchesBannerContainer from './launches-banner/LaunchesBannerContainer';
import ExplorePropertiesContainer from './components/explore-properties/ExplorePropertiesContainer';
import CompoundAmenities from './components/CompoundAmenities';
import AboutCompound from './components/AboutCompound';
import CompoundSlider from './components/CompoundsSlider';
import EntityTabs from './components/EntityTabs';
import { getImageSources } from '../../../helpers/images';
import PaymentPlansContainer from './PaymentPlansContainer';
import LocationOnMap from './components/LocationOnMap';
import CTA from './components/CTA';
import { useContext, useEffect, useRef, useState } from 'react';
import Form from './components/FormSection';
import {
  SearchContext,
  SearchContextInterface
} from '../../search-new/context/SearchContext';

interface CompoundViewProps {
  compound: Compound;
  hasAvailability: boolean;
  filterOptions: [];
  launches: [];
  showOffers: boolean;
  breadcrumbs: React.ReactElement;
}

const HEADER_HEIGHT = 70;

const CompoundView = ({
  compound,
  hasAvailability,
  filterOptions,
  launches,
  showOffers,
  breadcrumbs
}: CompoundViewProps) => {
  const images = getImages(compound.images);
  const [stickyDetailsHeight, setStickyDetailsHeight] = useState(0);
  const formRef = useRef(null);
  const stickySide = useRef<HTMLDivElement>(null);
  if (images.length == 1) images.push(images[0]);
  const { appliedFiltersCount } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const getStickySideTop = () => {
    return HEADER_HEIGHT + stickyDetailsHeight;
  };

  return (
    <Container>
      {images && images.length > 0 && (
        <CoverSection
          coverImagePath={compound?.coverImageUrl}
          breadcrumbs={breadcrumbs}
        />
      )}

      <div className="sticky-details-wrapper">
        <StickyDetails
          entity={compound}
          entityType={
            compound.isSuper ? EntityTypes.SUPER_COMPOUND : EntityTypes.COMPOUND
          }
          setStickyDetailsHeight={setStickyDetailsHeight}
        />
      </div>

      <div
        className="main-container container-fluid"
        style={{ marginTop: appliedFiltersCount > 0 ? '30px' : '0' }}
      >
        <div className="details-side">
          {compound?.extraFeatures?.length > 0 && (
            <ExtraFeatures
              features={[
                {
                  id: '1',
                  title: 'test',
                  description: 'Lurem Ipsum Lurem Ipsum Lurem Ipsum Lurem.',
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M11.875 24.375V22.5H5.625C4.9375 22.5 4.3125 22.225 3.8625 21.7625C3.4 21.3125 3.125 20.6875 3.125 20C3.125 18.7125 4.125 17.6375 5.3875 17.5125C5.4625 17.5 5.5375 17.5 5.625 17.5H24.375C24.4625 17.5 24.5375 17.5 24.6125 17.5125C25.2125 17.5625 25.7375 17.825 26.1375 18.2375C26.65 18.7375 26.925 19.45 26.8625 20.225C26.75 21.5375 25.5625 22.5 24.2375 22.5H18.125V24.375C18.125 26.1 16.725 27.5 15 27.5C13.275 27.5 11.875 26.1 11.875 24.375Z"
                        fill="#2C3138"
                      />
                      <path
                        d="M21.4877 2.5H16.5627C16.2127 2.5 15.9377 2.775 15.9377 3.125V5C15.9377 5.5125 15.5127 5.9375 15.0002 5.9375C14.8877 5.9375 14.7877 5.9125 14.6877 5.875C14.3252 5.75 14.0627 5.4 14.0627 5V3.125C14.0627 2.775 13.7877 2.5 13.4377 2.5H11.5502C11.2002 2.5 10.9252 2.775 10.9252 3.125V8.75C10.9252 9.2625 10.5002 9.6875 9.98773 9.6875C9.47523 9.6875 9.05023 9.2625 9.05023 8.75V5.9375V3.125C9.05023 2.7875 8.80023 2.525 8.46273 2.5H8.42523C6.25023 2.55 4.56273 4.4375 4.78773 6.625L5.25023 15.0625C5.28773 15.725 5.83773 16.25 6.50023 16.25H23.5002C24.1627 16.25 24.7127 15.725 24.7502 15.0625L25.2127 6.625C25.4377 4.4125 23.7002 2.5 21.4877 2.5Z"
                        fill="#2C3138"
                      />
                    </svg>
                  )
                },
                {
                  id: '1',
                  title: 'test',
                  description: 'Lurem Ipsum Lurem Ipsum Lurem Ipsum Lurem.',
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M11.875 24.375V22.5H5.625C4.9375 22.5 4.3125 22.225 3.8625 21.7625C3.4 21.3125 3.125 20.6875 3.125 20C3.125 18.7125 4.125 17.6375 5.3875 17.5125C5.4625 17.5 5.5375 17.5 5.625 17.5H24.375C24.4625 17.5 24.5375 17.5 24.6125 17.5125C25.2125 17.5625 25.7375 17.825 26.1375 18.2375C26.65 18.7375 26.925 19.45 26.8625 20.225C26.75 21.5375 25.5625 22.5 24.2375 22.5H18.125V24.375C18.125 26.1 16.725 27.5 15 27.5C13.275 27.5 11.875 26.1 11.875 24.375Z"
                        fill="#2C3138"
                      />
                      <path
                        d="M21.4877 2.5H16.5627C16.2127 2.5 15.9377 2.775 15.9377 3.125V5C15.9377 5.5125 15.5127 5.9375 15.0002 5.9375C14.8877 5.9375 14.7877 5.9125 14.6877 5.875C14.3252 5.75 14.0627 5.4 14.0627 5V3.125C14.0627 2.775 13.7877 2.5 13.4377 2.5H11.5502C11.2002 2.5 10.9252 2.775 10.9252 3.125V8.75C10.9252 9.2625 10.5002 9.6875 9.98773 9.6875C9.47523 9.6875 9.05023 9.2625 9.05023 8.75V5.9375V3.125C9.05023 2.7875 8.80023 2.525 8.46273 2.5H8.42523C6.25023 2.55 4.56273 4.4375 4.78773 6.625L5.25023 15.0625C5.28773 15.725 5.83773 16.25 6.50023 16.25H23.5002C24.1627 16.25 24.7127 15.725 24.7502 15.0625L25.2127 6.625C25.4377 4.4125 23.7002 2.5 21.4877 2.5Z"
                        fill="#2C3138"
                      />
                    </svg>
                  )
                },
                {
                  id: '1',
                  title: 'test',
                  description: 'Lurem Ipsum Lurem Ipsum Lurem Ipsum Lurem.',
                  icon: (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M11.875 24.375V22.5H5.625C4.9375 22.5 4.3125 22.225 3.8625 21.7625C3.4 21.3125 3.125 20.6875 3.125 20C3.125 18.7125 4.125 17.6375 5.3875 17.5125C5.4625 17.5 5.5375 17.5 5.625 17.5H24.375C24.4625 17.5 24.5375 17.5 24.6125 17.5125C25.2125 17.5625 25.7375 17.825 26.1375 18.2375C26.65 18.7375 26.925 19.45 26.8625 20.225C26.75 21.5375 25.5625 22.5 24.2375 22.5H18.125V24.375C18.125 26.1 16.725 27.5 15 27.5C13.275 27.5 11.875 26.1 11.875 24.375Z"
                        fill="#2C3138"
                      />
                      <path
                        d="M21.4877 2.5H16.5627C16.2127 2.5 15.9377 2.775 15.9377 3.125V5C15.9377 5.5125 15.5127 5.9375 15.0002 5.9375C14.8877 5.9375 14.7877 5.9125 14.6877 5.875C14.3252 5.75 14.0627 5.4 14.0627 5V3.125C14.0627 2.775 13.7877 2.5 13.4377 2.5H11.5502C11.2002 2.5 10.9252 2.775 10.9252 3.125V8.75C10.9252 9.2625 10.5002 9.6875 9.98773 9.6875C9.47523 9.6875 9.05023 9.2625 9.05023 8.75V5.9375V3.125C9.05023 2.7875 8.80023 2.525 8.46273 2.5H8.42523C6.25023 2.55 4.56273 4.4375 4.78773 6.625L5.25023 15.0625C5.28773 15.725 5.83773 16.25 6.50023 16.25H23.5002C24.1627 16.25 24.7127 15.725 24.7502 15.0625L25.2127 6.625C25.4377 4.4125 23.7002 2.5 21.4877 2.5Z"
                        fill="#2C3138"
                      />
                    </svg>
                  )
                }
              ]}
            />
          )}
          {launches?.length > 0 && (
            <LaunchesBannerContainer launches={launches} />
          )}

          <ExplorePropertiesContainer
            entityDetails={{
              type: SearchFiltersTypes.COMPOUNDS,
              id: compound.id,
              name: compound.name,
              resale_min_price: compound.prices?.resaleStartingPrice
            }}
            filterOptions={filterOptions}
            exploreLocation="ExplorePropertiesSection"
            hasAvailability={hasAvailability}
          />
          {compound?.amenities?.length > 0 && (
            <CompoundAmenities amenities={compound.amenities} />
          )}

          <AboutCompound
            name={compound.name}
            description={compound.description}
          />

          {compound?.faqs?.length > 0 && (
            <FAQs
              faqs={compound?.faqs}
              id={compound.id}
              name={compound.name}
              pageLocation="CompoundPage"
            />
          )}
          {compound?.phases?.length > 0 && (
            <CompoundSlider
              compounds={compound?.phases}
              developerName={compound.developerName}
            />
          )}
        </div>
        <div
          className="sticky-side hide-scrollbar"
          ref={stickySide}
          style={{
            top: getStickySideTop(),
            maxHeight: `calc(100vh - ${HEADER_HEIGHT + stickyDetailsHeight + 10}px)`
          }}
        >
          <div className="content">
            <EntityTabs
              entityId={compound?.id}
              entityName={compound.name}
              masterPlanImage={compound.masterPlan}
              mapData={{
                lat: compound?.parentCompound?.lat ?? compound.lat,
                long: compound?.parentCompound?.long ?? compound.long,
                id: compound?.parentCompound?.id ?? compound?.id,
                image: compound?.coverImageUrl,
                isFiltered: true,
                name: compound.name,
                geometry: {
                  type: compound?.geometry?.type,
                  coordinates: compound?.geometry?.coordinates
                },
                parent_id: compound?.parentCompound?.id
              }}
              entityType={EntityTypes.COMPOUND}
              onSahelMap={compound?.onSahelMap ?? false}
              entityImages={getImageSources(compound?.images)}
            />

            {compound?.paymentPlans?.length > 0 && (
              <PaymentPlansContainer
                entityType={EntityTypes.COMPOUND}
                paymentPlans={compound.paymentPlans}
                showOffers={showOffers}
                offers={compound.offers}
              />
            )}

            {compound?.geometry?.coordinates && (
              <div className="location-on-map">
                <LocationOnMap
                  mapData={{
                    lat: compound?.parentCompound?.lat ?? compound.lat,
                    long: compound?.parentCompound?.long ?? compound.long,
                    id: compound?.parentCompound?.id ?? compound?.id,
                    image: compound?.coverImageUrl,
                    isFiltered: true,
                    name: compound.name,
                    geometry: {
                      type: compound?.geometry?.type,
                      coordinates: compound?.geometry?.coordinates
                    },
                    parent_id: compound?.parentCompound?.id
                  }}
                />
              </div>
            )}
          </div>
          <div className="cta-wrapper ">
            <CTA
              entityType={EntityTypes.COMPOUND}
              entity={compound}
              eventExtraParams={{
                entity_type: compound.isSuper
                  ? EntityTypes.SUPER_COMPOUND
                  : EntityTypes.COMPOUND,
                cmpnd_id: compound.id,
                cmpnd_name: compound.name,
                org_id: compound.nawyOrganizationId ?? 1,
                min_price: compound.prices?.minPrice,
                max_price: compound.prices?.maxPrice,
                dev_price: compound.prices?.developerStartingPrice,
                resale_price: compound.prices?.resaleStartingPrice,
                area_id: compound?.areaId,
                area_name: compound?.areaName,
                dev_id: compound?.developerId,
                dev_name: compound?.developerName
              }}
            />
          </div>
        </div>
      </div>

      <Form compound={compound} formRef={formRef} />
    </Container>
  );
};

const Container = styled.div`
  background: linear-gradient(rgba(241, 241, 241, 0.4), rgba(255, 255, 255, 1));
  .headline {
    color: #2c3138;
    font-family: materialSemiBold;
    font-size: 22px;
    line-height: 22px;
    margin-bottom: 16px;
    text-transform: capitalize;
  }

  .sticky-details-wrapper {
    position: sticky;
    top: 170px;
    z-index: 1000;
    background: rgba(241, 241, 241, 0.4);
    backdrop-filter: blur(12.5px);

    &.lower-z-index {
      z-index: 99 !important;
    }
  }

  .main-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .details-side {
      width: calc(100% - 390px);
      display: flex;
      flex-direction: column;
      gap: 40px;
    }

    .sticky-side {
      position: sticky;
      border-radius: 18px;
      height: fit-content;
      border: 1px solid #e8e9ea;
      background: rgba(217, 217, 217, 0);
      width: 350px;
      display: flex;
      flex-direction: column;
      /* gap: 12px; */
      .content {
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
        height: 100%;
        position: relative;
        overflow-y: auto;
        padding: 16px;
        padding-bottom: 0;

        .headline {
          font-size: 18px;
        }
        z-index: 99;
        .btns-container {
          justify-content: space-between;

          > button,
          > a {
            width: 50%;
          }
        }
      }
      .cta-wrapper {
        width: 100%;
        z-index: 1001;
        padding: 16px;
      }
    }
  }
`;
export default CompoundView;
